<template>
  <card-wrapper v-if="showReward"
    id="RewardOptionsCard"
    :image="getImage()"
    :on-click="openConfig" :clear-active="clear"
    :is-active="isInCart"
    :max-height="maxHeight"
    :forced-height="106"
    :forced-width="284"
    :min-width="284"
    :css-class="`RewardsOptionCard ${isDisabled ? 'disabled' : null}`"
  >
    <template v-slot:textBody>
      <div class="rewards-card-content">
        <div class="header" :class="{'insufficientFunds': !canAfford(rewardOption) && !history}">
          {{ rewardOption.rewardName || rewardOption.name }}
        </div>
        
        <div v-if="rewardOption.discountRule" class="discount-text">
          • {{ getDiscountText(rewardOption.discountRule) }}
        </div>
        <div v-else-if="rewardOption.discountAmount" class="discount-text">
          • {{ $vuetify.t('$vuetify.account.rewards.discountOff', $options.filters.currency(rewardOption.discountAmount)) }}
        </div>

        <div v-if="hasTargets(rewardOption)" class="valid-items-text">
          • {{ $vuetify.t('$vuetify.account.rewards.validForSelectItems') }}
        </div>
        
        <div class="subheader-container">
          <div v-if="!isRewardValid(rewardOption)" class="subheader error-message">
            {{ getRewardErrorMessage(rewardOption) }}
          </div>
          <div v-else class="subheader redeem-points">
             {{ $vuetify.t('$vuetify.account.rewards.redeemFor') }} {{ rewardOption.redeemPoints | comma }} {{ $vuetify.t('$vuetify.account.rewards.points') }}
          </div>
          <div class="subheader expiration-text">
            {{ getExpirationText(rewardOption) }}
          </div>
        </div>
      </div>
  	</template>

    <template v-slot:description v-if="isDisabled">
      {{ $vuetify.t('$vuetify.account.rewards.inPersonRedeemable') }}
    </template>
    <!-- <template v-slot:description v-else-if="!!children && children.length">
      <template v-for="item in children">
        <v-layout v-for="order in item.childItemList" :key="order.code" class="menuItemContainer">
          <v-flex xs10>
            <div class="itemName">
              {{ order.qty || 1 }} x  {{ _get(order, 'childItemList[0].name', order.name) }}
            </div>
          </v-flex>

          <v-flex xs2>
            <span v-if="'itemPrice' in order && 'unitDiscount' in order && order.unitDiscount < 0" class="mr-2 caption" style="text-decoration: line-through;">
              <span class="red--text">
                {{ (order.itemPrice - order.unitDiscount) | currency}}
              </span>
            </span>

            <template v-if="'itemPrice' in order">
              <template v-if="order.itemPrice">
                {{ order.itemPrice | currency }}
              </template>
            </template>
            <common-price v-else class="mr-2" :init-charges="order.charges || []" />
          </v-flex>
        </v-layout>

        <ul class="cart-list">
          <li v-for="(config, index) in fetchConfigItems(item)" :key="index">
            <v-layout>
              <v-flex xs10>
                {{ config.qty ? `${config.qty} x ` : '' }}
                {{ config.name || config.value }}
              </v-flex>

              <v-flex xs2 class="text-xs-right caption grey--text">
                <span v-if="!!config.price" class="caption grey--text">
                  {{config.price | currency }}
                </span>
                <common-price v-else class="mr-2" :init-charges="config.charges || []" />
              </v-flex>
            </v-layout>
          </li>
        </ul>
      </template>
    </template> -->
  </card-wrapper>
</template>

<script>
import get from 'lodash/get';

import { mapMutations, mapActions, mapGetters } from 'vuex';
import { getCurrencySymbol, formatDiscountCap } from '@/services/currency.service';

import CardWrapper from "@/components/Wrappers/CardWrapper"
import CommonPrice from "@/components/Common/CommonPrice"

export default {
  props: {
    rewardOption: {
      type: Object
      // required: true
    },

    maxWidth: {
      type: String,
      default: '350px'
    },

    maxHeight: {
      type: String,
      default: '215px'
    },
    forcedHeight: {
      type: [String, Number],
      default: null
    },
    forcedWidth: {
      type: [String, Number],
      default: null
    },
    history: {
      type: Boolean,
      default: false
    },
    onlyAvailable: {
      type: Boolean,
      default: false
    },
    allowConfig: {
      type: Boolean,
      default: true
    }
  },

  extends: CardWrapper,
  components: { CardWrapper, CommonPrice },

  computed: {
    isDisabled() {
      return this.rewardOption && !this.rewardOption.onlineRedeemable && !this.history
    },

    showReward() {
      // Rewards in the cart are only visible if usable
      if (this.onlyAvailable && !this.canAfford(this.rewardOption))
        return false

      return !this.isDisabled || this.$route.name != 'store'
    },

    isInCart() {
      return !!(this.allowConfig && this.getActiveRewards && this.getActiveRewards.id == this.rewardOption.id)
    },

    children() {
      if (this.rewardOption.orderItem){
        return  this.rewardOption.orderItem.childItemList;
      } else {
        return []
      }
    },

    ...mapGetters([ 'getActiveRewards', 'getCustomerRewards', 'getExistingOrder', 'getCurrencyCode' ])
  },

  methods: {
    getImage() {
      const url = this.rewardOption.imageUrl || this.rewardOption.imageURL;
      if (url)
        return `${process.env.VUE_APP_API_IMAGE}${url}`;

      if (this.getStore.images && 'REWARD' in this.getStore.images && this.getStore.images.REWARD[0]) {
        const storeUrl = this.getStore.images.REWARD[0].url || this.getStore.images.REWARD[0].URL;
        if (storeUrl)
          return `${process.env.VUE_APP_API_IMAGE}${storeUrl}`;
      }

      return null;
    },
    _get(base, path, defaultVal=null) {
      return get(base, path, defaultVal)
    },

    getDiscountText(discountRule) {
      if (discountRule.percent) {
        const text = this.$vuetify.t('$vuetify.account.rewards.discountPercentOff', Math.round(discountRule.percent * 100));
        // Only percentage discounts can be capped; fixed amounts are already their own ceiling.
        const cap = formatDiscountCap(discountRule.maxDiscountAmount, this.getCurrencyCode);
        return cap ? this.$vuetify.t('$vuetify.account.rewards.discountUpTo', text, cap) : text;
      } else if (discountRule.amount) {
        const symbol = getCurrencySymbol(this.getCurrencyCode);
        return this.$vuetify.t('$vuetify.account.rewards.discountAmountOff', symbol, discountRule.amount);
      }
      return '';
    },

    getExpirationText(rewardOption) {
      if (rewardOption.validTo) {
        const expirationDate = new Date(rewardOption.validTo);
        const year = expirationDate.getFullYear();
        const month = String(expirationDate.getMonth() + 1).padStart(2, '0');
        const day = String(expirationDate.getDate()).padStart(2, '0');
        return this.$vuetify.t('$vuetify.account.rewards.offerExpires', `${year}-${month}-${day}`);
      }
      return this.$vuetify.t('$vuetify.account.rewards.noExpiration');
    },

    getRewardErrorMessage(reward) {
      if (!reward) {
        return this.$vuetify.t('$vuetify.account.rewards.unavailable');
      }

      if (this.isDisabled) {
        return this.$vuetify.t('$vuetify.account.rewards.inPersonRedeemable');
      }

      if (!this.canAfford(reward)) {
        return this.$vuetify.t('$vuetify.account.rewards.insufficientFunds');
      }

      if (this.getActiveRewards && reward && this.getActiveRewards.id != reward.id) {
        return this.$vuetify.t('$vuetify.account.rewards.removeFirst');
      }

      if (!('menuItem' in reward) && this.getActiveRewards && this.getActiveRewards.id == reward.id) {
        return this.$vuetify.t('$vuetify.account.rewards.alreadyInCart', [reward.rewardName]);
      }

      return '';
    },

    isRewardValid(reward) {
      if (!reward) {
        return false;
      }
      if (this.isDisabled) {
        return false;
      }

      if (!this.canAfford(reward)) {
        return false;
      }

      if (this.getActiveRewards && reward && this.getActiveRewards.id != reward.id) {
        return false;
      }
      return true;
    },

    canAfford(rewardOption) {
      // Find all previous orders that used a redemptionItem
      let previousRewardsSum
      if (this.getExistingOrder && this.getExistingOrder.length) {
        previousRewardsSum = this.getExistingOrder.reduce((accumulator, order) => {
          if (order.redemptionItems && order.redemptionItems.length)
            return (accumulator || 0) + order.redemptionItems.reduce((subSum, reward) => subSum + reward.redeemPoints, 0)
          return accumulator
        }, 0)
      } else {
        previousRewardsSum = 0
      }

      return get(this.getCustomerRewards, 'points', 0) >= rewardOption.redeemPoints + previousRewardsSum
    },

    checkRewardValididity(reward) {
      if (!this.allowConfig || !reward)
        return false

      if (this.isDisabled) {
        this.$store.dispatch('showSnack', {
          text: this.$vuetify.t('$vuetify.account.rewards.inPersonRedeemable'),
          color: 'error'
        })

        return false
      }

      if (!this.canAfford(reward)) {
        this.$store.dispatch('showSnack', {
          text: this.$vuetify.t('$vuetify.account.rewards.insufficientFunds'),
          color: 'error'
        })

        return false
      }

      if (this.getActiveRewards && reward && this.getActiveRewards.id != reward.id) {
        this.$store.dispatch('showSnack', {
          text: this.$vuetify.t('$vuetify.account.rewards.removeFirst'),
          color: 'error'
        })

        return false
      }

      if (!('menuItem' in reward) && this.getActiveRewards && this.getActiveRewards.id == reward.id) {
        this.showSnack({
          text: this.$vuetify.t('$vuetify.account.rewards.alreadyInCart', [reward.rewardName]),
          color: 'secondary'
        })

        this.showCart()
      }

      return true
    },

    openConfig(reward = this.rewardOption) {
      if (!this.checkRewardValididity(reward))
        return

      if ('menuItem' in reward) {
        if (this.getActiveRewards && this.getActiveRewards.id == reward.id) {
          this.setIsCartItem(true)
          this.SET_REWARDS_CONFIG(this.getActiveRewards || reward)
        } else {
          this.SET_REWARDS_CONFIG(reward)
        }
      } else if (!this.getActiveRewards) {
        this.SET_ACTIVE_REWARDS(reward)

        this.showSnack({
          text: this.$vuetify.t('$vuetify.common.addedToCart', [reward.rewardName]),
          color: 'secondary'
        })

        this.fetchShoppingCart()
        this.showCart()
      }
    },
    clear() {
      this.SET_ACTIVE_REWARDS(null)
      this.fetchShoppingCart()
    },
    showCart() {
      if (this.$vuetify.breakpoint.smAndDown)
        this.$bus.$emit('toggleCart', true)
    },

    fetchConfigItems(item) {
      let configItems = []
      // History items use standard childItemList wrapper structure. Fallback is normal case
      const list = get(item, 'childItemList[0].itemAttributeList', null) || get(item, 'itemAttributeList', [])

      list.map(option => {
        option.attrValueList.forEach(opt => {
          configItems.push(opt)
        })
      })

      return configItems.filter(Boolean)
    },

    hasTargets(reward) {
      const itemRelationList = get(reward, 'menuItem.itemRelationList', []);
      return itemRelationList.some(relation => 
        get(relation, 'targets', []).length > 0
      );
    },

    ...mapMutations([ 'SET_REWARDS_CONFIG', 'SET_ACTIVE_REWARDS' ]),
    ...mapActions([ 'fetchShoppingCart', 'showSnack', 'setIsCartItem' ])
  },

  mounted() {
    this.$root.$refs.redeemables = this;
  }
}
</script>

<style scoped>
  #RewardOptionsCard .header {
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--v-primary-base);
  }

  .info-row {
    margin-bottom: 4px;
    font-size: 14px;
  }

  .itemName {
    font-size: 16px;
    color: var(--v-primary-base);
  }
  .itemPrice {
    font-size: 14px;
    color: var(--v-secondary-base);
  }

  .insufficientFunds {
    color: red !important;
  }

  .rewards-card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
  }

  .subheader-container {
    margin-top: auto;
  }

  .redeem-points {
    color: var(--v-primary-base);
    font-weight: normal;
  }

  .discount-text {
    color: grey;
    font-size: 11px;
    font-weight: 600;
  }

  .valid-items-text {
    color: grey;
    font-size: 11px;
    font-weight: 600;
  }

  .expiration-text {
    font-weight: normal;
    font-size: 11px !important;
    margin-top: 0px !important;
  }

  .error-message {
    color: #D8000C;
  }
</style>
